export const checkboxTheme = {
  primary: {
    display: "flex",
    "align-items": "center",
    "font-size": "12px",
    cursor: "pointer",
    "margin-bottom": "0px !important",
    "margin-top": "10px",
    width: "min-content",
    ".input": {
      width: "0px",
      height: "0px",
      "z-index": 10,
      opacity: 0,
    },
    ".checkbox-input": {
      "margin-right": "0.25rem",
    },
    ".svg-block": {
      width: "25px",
      height: "25px",
      background: "#EDEDED",
      overflow: "hidden",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
    },
    ".icon": {
      width: "18px",
    },
  },
  secondary: {
    display: "flex",
    "align-items": "center",
    "font-size": "12px",
    cursor: "pointer",
    "margin-bottom": "0px !important",
    "margin-top": "10px",
    width: "min-content",
    ".input": {
      width: "0px",
      height: "0px",
      "z-index": 10,
      opacity: 0,
    },
    ".checkbox-input": {
      "margin-right": "0.25rem",
    },
    ".svg-block": {
      border: "2px solid rgb(163 163 163)",
      width: "20px",
      height: "20px",
      background: "transparent",
      overflow: "hidden",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
    },
    ".icon": {
      width: "18px",
    },
  },
  checked: {
    display: "flex",
    "align-items": "center",
    "font-size": "12px",
    cursor: "pointer",
    "margin-bottom": "0px !important",
    "margin-top": "10px",
    width: "min-content",
    ".input": {
      width: "0px",
      height: "0px",
      "z-index": 10,
      opacity: 0,
    },
    ".checkbox-input": {
      "margin-right": "0.25rem",
    },
    ".svg-block": {
      width: "20px",
      height: "20px",
      background: "black",
      overflow: "hidden",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
    },
    ".icon": {
      width: "18px",
      fill: "white",
    },
  },
};
